export const ANALYTICS_CONSENT_COOKIE = "truegrind_analytics_consent";
export type AnalyticsConsent = "granted" | "denied" | null;
export function browserAnalyticsConsent(): AnalyticsConsent {
  if (typeof document === "undefined") return null;
  const value = document.cookie.split("; ").find((entry) => entry.startsWith(`${ANALYTICS_CONSENT_COOKIE}=`))?.split("=")[1];
  return value === "granted" || value === "denied" ? value : null;
}
